import React from 'react'
import styled from 'styled-components'
import InputTC from '../../../../../components/input-tc/input-tc'
import SelectTC from '../../../../../components/select-tc/select-tc'
import { device } from '../../../../../config/theme/breakpoints'
import { User } from '@styled-icons/boxicons-regular'
import { CreditCard } from '@styled-icons/feather'
import { PhoneCall } from '@styled-icons/feather'
import { Calendar } from '@styled-icons/fa-regular'
import { UserXmark } from '@styled-icons/fa-solid'
import { Users } from '@styled-icons/heroicons-solid'
import { FaceSmile } from '@styled-icons/fa-regular'
import { AirlineSeatReclineExtra } from '@styled-icons/material-twotone'
import bus from '../../../../../assets/img/bus_opaco.png'
import CalendarTC from '../../../../../components/calendar-tc/calendar-tc'

const ContainerForm = styled.div`
    width: 100%;
    border-radius: 20px;
    margin-bottom: 40px;
    box-shadow: 0px 2px 12px 0px #d9d9d9;
`
const ContainerHeader = styled.div`
    width: 100%;
    background: ${p => p.theme.palette.primary.main};
    border-radius: 20px 20px 0 0;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 20px;
    height: 55px;

    > div:nth-child(2) {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    > div svg {
        width: 25px;
    }
`
const ContainerBody = styled.div`
    padding: 15px 12px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
    position: relative;

    > div svg {
        max-width: 20px;
        color: ${p => p.theme.palette.primary.main};
    }

    > div a {
        color: ${p => p.theme.palette.secondary.main};
        text-decoration: underline;
        font-size: 13px;
        margin-left: 6px;
    }

    > div{
        width: 100%;

        @media ${device.tablet}{
            width: 46%;
        }

        @media ${device.laptop}{
            width: 30%;
        }
    }
`
const ContainerBus = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    width: auto !important;

    > img {
        max-width: 100px;
    }
`

const customWidthCalendar = `
    width: 97%;
`
interface IOwnProps{
    nro: string;
}

const FormUserItem: React.FunctionComponent<IOwnProps> = ({ nro }) => {
    
  return (
    <ContainerForm>
        <ContainerHeader>
            <div><b>Pasajero {nro}</b></div>
            <div>
                <div><AirlineSeatReclineExtra /></div>
                <p>Asiento Nº</p>
            </div>
        </ContainerHeader>
        <ContainerBody>
            <div><SelectTC textHolder='Tipo de documento'/></div>
            <div><InputTC type="text" textHolder='Número de documento' icon={<CreditCard />}/></div>
            <div><InputTC type="text" textHolder='Teléfono' icon={<PhoneCall />}/></div>
            <div><InputTC type="text" textHolder='Nombres' icon={<User />}/></div>
            <div><InputTC type="text" textHolder='Apellido Paterno' icon={<User />}/></div>
            <div><InputTC type="text" textHolder='Apellido Materno' icon={<User />}/></div>
            <div>
                <CalendarTC
                    icon={<Calendar />}
                    textHolder='Fecha de nacimiento'
                    className={customWidthCalendar}
                />
            </div>
            <div><InputTC type="text" textHolder='Sexo' icon={<Users />}/></div>
            <div><InputTC type="text" textHolder='Edad' icon={<FaceSmile />}/></div>
            <div><SelectTC textHolder='Lugar de embarque'/></div>
            <div><SelectTC textHolder='Lugar de desembarque'/></div>            
            <div><UserXmark /><a href='/#'>Eliminar Pasajero</a></div>
            <ContainerBus>
                <img src={bus} alt='bus'/>
            </ContainerBus>
        </ContainerBody>
    </ContainerForm>
  )
}

export default FormUserItem